<template>
  <div class="quest_container numerai-paper">
    <div class="row no-gutters">
      <!-- <div class="col-3 d-none d-sm-block quest_image"></div> -->
      <div class="col-12 col-sm-12 pa-6 px-8">
        <div class="flexrow space_between full-width mb-4">
          <div class="top_row_first">
            <h2 class="quest_title">{{ title }}</h2>
            <div class="status">
              <div v-if="complete" class="status_container status_complete">
                <span class="material-icons">
                  task_alt
                </span>
                Complete!
              </div>
              <div v-if="!complete" class="status_container ">
                <span class="material-icons">
                  radio_button_unchecked
                </span>
                Incomplete
              </div>
            </div>
          </div>
          <div class="top_row_last">
            <NumeraiCurrency
              v-if="value > 0"
              :value="value"
              class="quest_value color-nmr"
            />
            <span v-else class="null-number"> </span>
          </div>
        </div>
        <div class="description">
          <slot>
            Test
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NumeraiTooltip from '@/components/shared/NumeraiTooltip'
import NumeraiCurrency from '@/components/shared/NumeraiCurrency'

export default {
  components: {
    // NumeraiTooltip,
    NumeraiCurrency,
  },
  props: {
    title: { type: String, default: 'Quest Title' },
    complete: { type: Boolean, default: false },
    value: { type: Number, default: 0 },
  },
}
</script>

<style scoped>
.quest_container {
  /* display: flex; */
  /* justify-content: space-between;
  align-items: center; */
  color: var(--color-secondary);
  margin: 0;
  padding: 0;
  font-size: 1.2rem;
  max-width: 100%;
}

.quest_title {
  text-transform: none;
  font-family: var(--ui-font);
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  color: var(--color-primary);
  margin-bottom: 0.2em;
}

.description {
  font-size: 1rem;
}

.status_container {
  font-weight: 600;
  color: var(--color-tertiary);
  font-size: 1rem;
}
.status_container .material-icons {
  vertical-align: top;
  /* font-size: 1.5rem; */
}

.status_container.status_complete {
  color: var(--color-happy-green);
}

.quest_value {
  font-weight: 600;
}

.quest_image {
  background-size: cover;
  background-image: url(/img/stake_intro_cover.jpg);
  background-position: center;
  min-height: 50px;
}
</style>
